export default __webpack_public_path__ + "static/media/DocumentTypeRtf.74c93dc8.svg";